






















import { Component, Prop, Vue } from 'vue-property-decorator'
import * as db from '@shared/types/database'
import { Question, Response } from '@/store/modules/survey-store-module'
import { getOpenEnd } from '../Utilities/SurveyUtilities'
import { cleanForLooseMatch } from '../Utilities/TextUtility'
import OpenEnd from './OpenEnd.vue'
import store from '@/store'
import * as htmlToText from 'html-to-text'

@Component({
  components: {
    OpenEnd
  }
})
export default class OpenEnds extends Vue {
  @Prop({ required: true }) responses!: Response[] // assumes that response[] is already filtered for hidden open ends
  @Prop({ required: true }) question!: Question // assumes question will have unfiltered responses (does not care about hidden open ends)
  @Prop({ required: true }) filter!: string
  @Prop({ required: false }) totalResponseCount!: number
  isTextArea: boolean = (this.question.type === db.QuestionType.TextArea)

  get responseCount () {
    return this.question.hasExplainOpt || (this.question.type === db.QuestionType.TextArea)
      ? this.totalResponseCount
      : this.allMatchingOpenEnds.length
  }

  get visibleOpenEndResponses () {
    return this.filterForOpenEnds(this.responses)
  }

  get allOpenEndResponses () {
    return this.filterForOpenEnds(this.question.responses!)
  }

  responseValue (response: Response) {
    const openEnd = getOpenEnd(response, this.question)

    // Remove script tags from the open end since we are enabling v-html on user input strings
    const sanitizedOpenEnd = htmlToText.fromString(openEnd!)

    // Case insensitive reg expression ... will surround all matching phrases with bold tag, regardless of case
    const searchTextRegExp = new RegExp(this.filter, 'i')
    return sanitizedOpenEnd.replace(searchTextRegExp, '<b>$&</b>')
  }

  respondentForResponse (response: Response) {
    return store.getters.survey.respondentById(response.respondentSurveyId!)
  }

  filterForOpenEnds (responses: Response[]) {
    return responses.filter(response => !!getOpenEnd(response, this.question))
  }

  get visibleMatchingOpenEnds () {
    return this.filterByTextInput(this.visibleOpenEndResponses).sort((a, b) => {
      return getOpenEnd(a, this.question)!.length > getOpenEnd(b, this.question)!.length ? -1 : 1
    })
  }

  get allMatchingOpenEnds () {
    return this.filterByTextInput(this.allOpenEndResponses).sort((a, b) => {
      return getOpenEnd(a, this.question)!.length > getOpenEnd(b, this.question)!.length ? -1 : 1
    })
  }

  filterByTextInput (openEnds: Response[]) {
    if (!this.filter) return openEnds
    return openEnds.filter((openEnd) => {
      const cleaned = cleanForLooseMatch(getOpenEnd(openEnd, this.question))
      return cleaned.includes(this.filter.toLowerCase())
    })
  }

  get headerText () {
    if (this.isTextArea) return 'Responses'
    if (this.question.hasExplainOpt) return 'Explanations'
    if (this.question.hasOtherOpt) return 'Other'
  }
}
